import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flightStopCount'
})

/**
 * Takes the number of flight stops and add the prefixes stop/stops or Nonstop
 * @example
 * stopsCount: number = 2 will be formatted to '2 stops'
 * stopsCount: number = 0 will be formatted to 'Nonstop'
 * @constructor
 * @param {number} stopsCount - number of stops.
 */
export class FlightStopCountPipe implements PipeTransform {
  transform(stopsCount: number): string {
    return stopsCount === 0
      ? 'Nonstop'
      : stopsCount === 1
      ? `${stopsCount} stop`
      : `${stopsCount} stops`;
  }
}
